import { render } from "./SegmentsPopup.vue?vue&type=template&id=1fec42a0&scoped=true"
import script from "./SegmentsPopup.vue?vue&type=script&lang=js"
export * from "./SegmentsPopup.vue?vue&type=script&lang=js"

import "./SegmentsPopup.vue?vue&type=style&index=0&id=1fec42a0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fec42a0"]])

export default __exports__